import { markUiObject as __markUi } from '@/i18n/display'
// Presentation only: retain original routes and server-side permission keys.
export const merchantDirectories=[
  __markUi({path:'/platform/branchlist',key:'branchlist',label:'全部',type:0}, {"label":"全部"}),
  __markUi({path:'/platform/fabriclist',key:'fabriclist',label:'面料商家',type:3}, {"label":"面料商家"}),
  __markUi({path:'/platform/designers',key:'designers',label:'版型设计商家',type:4}, {"label":"版型设计商家"}),
  __markUi({path:'/platform/manufacturers',key:'manufacturers',label:'成衣生产厂家',type:5}, {"label":"成衣生产厂家"}),
]
export function allowedMerchantDirectories(functions:any[]) {
  const entries=merchantDirectories.filter(entry=>(functions||[]).some(item=>item.functionKey===entry.key
    && item.disabled!==true && Number(item.disabled||0)===0))
  if(entries.some(item=>item.type===0))entries.splice(1,0,__markUi({path:'/platform/branchlist?businessRole=2',key:'branchlist',label:'服装门店',type:2}, {"label":"服装门店"}))
  return entries
}
export function consolidateMerchantMenus(items:any[]):any[] {
  const paths=new Set(merchantDirectories.map(item=>item.path))
  const members=items.filter(item=>paths.has(item.functionUrl))
  if(!members.length)return items
  const chosen=members.find(item=>item.functionUrl==='/platform/branchlist') || members[0]
  let inserted=false
  return items.flatMap(item=>{
    if(!paths.has(item.functionUrl))return [item]
    if(inserted)return []
    inserted=true
    // This copy is consumed only by the sidebar, never written into the permission store.
    return [{...chosen,functionName:'入驻商家',functionKey:'branchlist'}]
  })
}
